import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetNotificationsByAssociationId } from '../selectors/notifications';

import UserFaces from './user-faces';
import NotificationsBubble from 'components/NotificationsBubble';

const MessageThreadCTA = ({ replies, repliers, hasNotifications, t, onClick }) => {
    if (!replies) {
        return null;
    }

    return (
        <div className="message-thread-cta" onClick={onClick}>
            {
                repliers.length ? (
                    <UserFaces users={repliers} size="xsmall" />
                ) : null
            }

            {
                t('Replies_count', {
                    count: replies
                })
            }

            {
                hasNotifications ? <NotificationsBubble count={1} typeDot={true}  /> : null
            }
        </div>
    );
}

const makeMapStateToProps = () => {
    const getNotificationsByAssociationId = makeGetNotificationsByAssociationId();

    return ({ notifications }, ownProps) => ({
        hasNotifications: Boolean(getNotificationsByAssociationId(notifications.items, ownProps.id).length)
    });
}

export default connect(makeMapStateToProps)(withTranslation('chat')(MessageThreadCTA));
